/// <reference types="@types/googlemaps" />
/*global google*/
import React, { useState, useMemo, useEffect, useRef } from "react";
import { GoogleMap, StreetViewPanorama } from "@react-google-maps/api";
import { CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

function DirectionsService({ fullAddress, defaultMapCenter, setPanoOptions, setIsLoading, appNotify }) {
  useEffect(() => {
    if (!fullAddress) return;
    setIsLoading(true);
    const directionsService = new google.maps.DirectionsService();
    directionsService.route({
      origin: fullAddress,
      destination: fullAddress,
      travelMode: google.maps.DirectionsTravelMode.DRIVING
    }, function(res, status) {
      try {
        if (status === google.maps.DirectionsStatus.OK) {
          const streetLatLng = res?.routes?.[0]?.legs?.[0]?.start_location;
          if (streetLatLng) {
            const computedHeading = google.maps.geometry.spherical.computeHeading(streetLatLng, defaultMapCenter);
            if (computedHeading == null) return;
            const panoOptions = {
              position: streetLatLng,
              pov: {
                heading: computedHeading,
                pitch: 0
              },
              visible: true,
              enableCloseButton: false
            }
            setPanoOptions(panoOptions);
            setIsLoading(false);
          }
        } else {
          throw new Error(res);
        }
      } catch (error) {
        appNotify(`Failed to fetch Street View: ${error.message}`, 'error');
        setIsLoading(false);
      }
    });
  }, [fullAddress, defaultMapCenter, setPanoOptions, setIsLoading, appNotify]);
  return null;
}

function PropertyDetailsStreetView({ propertyDetailsData, appNotify }) {  
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [panoOptions, setPanoOptions] = useState(null);
  const panoramaRef = useRef(null);
  const defaultMapCenter = useMemo(() => {
    return { lat: propertyDetailsData?.latitude, lng: propertyDetailsData?.longitude };
  }, [propertyDetailsData]);

  // const onPanoramaStatusChanged = () => {
  //   console.log(panoramaRef)
  // }
  if (!propertyDetailsData) return null;
  return (        
    <GoogleMap
      zoom={8}
      center={defaultMapCenter}
      mapContainerStyle={{ height: "23vh" }}
    >
      {isLoading &&
        <div className={classes.loadingContainer}>
          <CircularProgress />
        </div>
      }
      <DirectionsService
        fullAddress={propertyDetailsData.fullAddress}
        defaultMapCenter={defaultMapCenter}
        setPanoOptions={setPanoOptions}
        setIsLoading={setIsLoading}
        appNotify={appNotify}
      />
      {panoOptions &&
        <StreetViewPanorama
          options={panoOptions}
          onLoad={(ref) => panoramaRef.current = ref}
          // onStatusChanged={onPanoramaStatusChanged}
        />
      }
    </GoogleMap>
  )
}

const useStyles = makeStyles(theme => ({
  loadingContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ffffffab'
  }
}));

export default PropertyDetailsStreetView;
  